import { MdOutlineGroupWork, MdSportsBasketball } from "react-icons/md";
import { FcSportsMode } from "react-icons/fc";
import {
  FaMapMarkerAlt,
  FaTrophy,
  FaStar,
  FaRegRegistered,
  FaStarOfLife,
} from "react-icons/fa";
import { useParams } from "react-router-dom";
import { communityData, roles } from "../../helper/constant";
import { LuContactRound } from "react-icons/lu";
import { PiClubFill, PiGenderNonbinaryFill } from "react-icons/pi";

const Overview = ({ data }) => {
  return (
    // <div className="grid md:grid-cols-3 gap-6">
    <div>
      {/* Left Column - Main Info */}
      <div className="md:col-span-2 space-y-6">
        <div className="bg-white rounded-2xl md:shadow-lg md:border border-gray-100 md:p-6 p-0">
          {/* <div className="flex items-center gap-3 mb-6">
            <div className="bg-[#2BACE240] p-2 rounded-lg">
              <FcSportsMode className="text-[#2BACE2]" size={20} />
            </div>
            <h2 className="md:text-2xl text-xl font-semibold text-gray-700">
              Sporting Interests
            </h2>
          </div> */}

          {/* Crew Specialisation */}
          {data?.userType == roles?.CREW && (
            <div className=" w-full mb-3 bg-gradient-to-br from-white to-[#2BACE210] p-5 rounded-xl border-2 border-gray-200 ">
              <div className="flex items-center gap-2 mb-3">
                <FaStarOfLife size={18} className="text-blue-600" />
                <h4 className="font-semibold text-gray-700">
                  Crew Specialisation
                </h4>
              </div>

              <div className="flex flex-wrap gap-2 max-h-36 overflow-y-auto">
                {data?.crewSpecialisation?.length > 0 ? (
                  data?.crewSpecialisation?.map((sport, index) => (
                    <span
                      key={index}
                      className="bg-white border-2 border-gray-200 text-gray-700 px-3 py-1 rounded-full text-xs font-medium hover:border-[#2BACE2] hover:text-[#2BACE2] transition-all cursor-pointer"
                    >
                      {sport}
                    </span>
                  ))
                ) : (
                  <span className="bg-white border-2 border-gray-200 text-gray-700 px-3 py-1 rounded-full text-xs font-medium hover:border-[#2BACE2] hover:text-[#2BACE2] transition-all cursor-pointer">
                    N/A
                  </span>
                )}
              </div>
            </div>
          )}
          <div className="flex gap-5 md:flex-row flex-col">
            {/* Primary Sport */}
            {data?.primarySports?.length > 0 && (
              <div className="md:w-1/2 w-full bg-gradient-to-br from-white to-[#2BACE210] p-5 rounded-xl border-2 border-gray-200 ">
                <div className="flex items-center gap-2 mb-3">
                  <FaStar className="text-blue-600" size={20} />
                  <h4 className="font-semibold text-gray-700">Primary Sport</h4>
                </div>

                <div className="flex flex-wrap gap-2 max-h-36 overflow-y-auto">
                  {data?.primarySports?.map((sport, index) => (
                    <span
                      key={index}
                      className="bg-white border-2 border-gray-200 text-gray-700 px-3 py-1 rounded-full text-xs font-medium hover:border-[#2BACE2] hover:text-[#2BACE2] transition-all cursor-pointer"
                    >
                      {sport}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {/* Additional Sports */}
            {data?.multirepresentingGames?.length > 0 && (
              <div className="md:w-1/2 w-full bg-gradient-to-br from-white to-[#2BACE210] p-4 rounded-xl border border-gray-200">
                <div className="flex items-center gap-3 mb-2">
                  <MdSportsBasketball size={18} className="text-blue-600 " />
                  <h4 className="font-semibold text-gray-700">
                    Additional Sports
                  </h4>
                </div>

                <div className="flex flex-wrap gap-2 max-h-36 overflow-y-auto">
                  {data?.multirepresentingGames?.map((sport, index) => (
                    <span
                      key={index}
                      className="bg-white border-2 border-gray-200 text-gray-700 px-3 py-1 rounded-full text-xs font-medium hover:border-[#2BACE2] hover:text-[#2BACE2] transition-all cursor-pointer"
                    >
                      {sport}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* age/gender */}
          {data?.userType != roles?.PLAYER && (
            <div className="flex gap-5 md:flex-row flex-col mt-3">
              <div className="md:w-1/2 w-full bg-gradient-to-br from-white to-[#2BACE210] p-4 rounded-xl border border-gray-200">
                <div className="flex items-center gap-3 mb-2">
                  <MdOutlineGroupWork size={18} className="text-blue-600 " />
                  <h4 className="font-semibold text-gray-700">
                    Age Group Catered
                  </h4>
                </div>

                <div className="flex flex-wrap gap-2 max-h-36 overflow-y-auto">
                  {data?.multiAgeGroup?.length > 0 ? (
                    data?.multiAgeGroup?.map((sport, index) => (
                      <span
                        key={index}
                        className="bg-white border-2 border-gray-200 text-gray-700 px-3 py-1 rounded-full text-xs font-medium hover:border-[#2BACE2] hover:text-[#2BACE2] transition-all cursor-pointer"
                      >
                        {sport}
                      </span>
                    ))
                  ) : (
                    <span className="bg-white border-2 border-gray-200 text-gray-700 px-3 py-1 rounded-full text-xs font-medium hover:border-[#2BACE2] hover:text-[#2BACE2] transition-all cursor-pointer">
                      N/A
                    </span>
                  )}
                </div>
              </div>
              {/* Primary Sport */}
              <div className="md:w-1/2 w-full bg-gradient-to-br from-white to-[#2BACE210] p-5 rounded-xl border-2 border-gray-200 ">
                <div className="flex items-center gap-2 mb-3">
                  <PiGenderNonbinaryFill className="text-blue-600" size={20} />
                  <h4 className="font-semibold text-gray-700">
                    Gender Catered
                  </h4>
                </div>

                <div className="flex flex-wrap gap-2 max-h-36 overflow-y-auto">
                  {data?.genderServing?.length > 0 ? (
                    data?.genderServing?.map((sport, index) => (
                      <span
                        key={index}
                        className="bg-white border-2 border-gray-200 text-gray-700 px-3 py-1 rounded-full text-xs font-medium hover:border-[#2BACE2] hover:text-[#2BACE2] transition-all cursor-pointer"
                      >
                        {sport}
                      </span>
                    ))
                  ) : (
                    <span className="bg-white border-2 border-gray-200 text-gray-700 px-3 py-1 rounded-full text-xs font-medium hover:border-[#2BACE2] hover:text-[#2BACE2] transition-all cursor-pointer">
                      N/A
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}
          {/* contact info */}
          {data?.userType != roles?.PLAYER &&
            (!data?.contactIsHide || !data?.emailIsHide) && (
              <div className="w-full mt-4 bg-gradient-to-br from-white to-[#2BACE210] p-4 rounded-xl border border-gray-200">
                <div className="flex items-center gap-3 mb-3">
                  <LuContactRound size={18} className="text-blue-600" />
                  <h4 className="font-semibold text-gray-700">Contact Info</h4>
                </div>

                <div className="space-y-2 text-sm font-medium text-gray-700">
                  {data?.email && !data?.emailIsHide && (
                    <div className="grid grid-cols-[120px_10px_1fr]">
                      <span>E-mail</span>
                      <span>:</span>
                      <span className="pl-4 break-all">{data?.email}</span>
                    </div>
                  )}

                  {data?.contactNo > 0 && !data?.contactIsHide && (
                    <div className="grid grid-cols-[120px_10px_1fr]">
                      <span>Contact No.</span>
                      <span>:</span>
                      <span className="pl-4">{`${data?.countryCode || ""} ${
                        data.contactNo
                      }`}</span>
                    </div>
                  )}
                </div>
              </div>
            )}

          {data?.userType == roles?.CREW && (
            <div className="w-full mt-4 bg-gradient-to-br from-white to-[#2BACE210] p-4 rounded-xl border border-gray-200">
              <div className="flex items-center gap-3 mb-3">
                <FaRegRegistered size={18} className="text-blue-600" />
                <h4 className="font-semibold text-gray-700">
                  Registration Info
                </h4>
              </div>

              <div className="space-y-2 text-sm font-medium text-gray-700">
                <div className="grid grid-cols-[150px_10px_1fr]">
                  <span>Registered Crew</span>
                  <span>:</span>
                  <span className="pl-4 break-all">
                    {data?.areYouCrewOrAssociation ? "Yes" : "No"}
                  </span>
                </div>
                <div className="grid grid-cols-[150px_10px_1fr]">
                  <span>Registration Number</span>
                  <span>:</span>
                  <span className="pl-4 break-all">
                    {data?.crewOrAssociationId || "N/A"}
                  </span>
                </div>
                <div className="grid grid-cols-[150px_10px_1fr]">
                  <span>Registered With</span>
                  <span>:</span>
                  <span className="pl-4 break-all">
                    {data?.registeredWith || "N/A"}
                  </span>
                </div>
                <div className="grid grid-cols-[150px_10px_1fr]">
                  <span>Proof Of Membership</span>
                  <span>:</span>
                  {data?.proofOfMembershipPath ? (
                    <div
                      className="h-40 w-40 border rounded-lg border-highlight"
                      style={{
                        backgroundImage: `url("${data?.proofOfMembershipPath}")`,
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    ></div>
                  ) : (
                    <span className="pl-4 break-all">N/A</span>
                  )}
                </div>
              </div>
            </div>
          )}
          {/* Location */}
          {data?.location?.address && (
            <div className="w-full mt-4 max-h-24 overflow-y-auto bg-gradient-to-br from-white to-[#2BACE210] p-4 rounded-xl border border-gray-200">
              <div className="flex items-center gap-3 mb-2">
                <FaMapMarkerAlt size={18} className="text-blue-600" />
                <h4 className="font-semibold text-gray-700">Location</h4>
              </div>
              <p className="text-gray-700 text-sm font-medium leading-relaxed">
                {data?.location?.address}
              </p>
            </div>
          )}

          {/* Amenties */}
          {data?.userType == roles?.VENUE &&
            data?.venueAmenities?.map((item, index) => {
              return (
                <div key={item?.name} className="w-full mt-8">
                  <h2 className="md:text-xl text-lg md:font-bold font-semibold text-gray-800 flex items-center gap-2 md:my-5 my-4">
                    <div className="w-1 h-6 bg-[#2bace2] rounded-full"></div>
                    {item?.name == "Accessibility" && "♿"}
                    {item?.name == "Amenities" && "🏢"}
                    {item?.name == "Toilets" && "🚻"}
                    {item?.name == "Access" && "🚪"} {item?.name}
                  </h2>
                  <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
                    {item?.items?.map((amenity, subIndex) => (
                      <div
                        key={amenity.key}
                        className={`p-2 rounded-xl border-2 transition-all ${
                          amenity?.isSelected
                            ? "border-[#2bace2] bg-[#2bace2]/10 text-[#2bace2]"
                            : "border-gray-200 "
                        }`}
                      >
                        <div className="flex flex-col items-center gap-2">
                          <div
                            className={`rounded-full flex items-center justify-center `}
                          >
                            <div className="rounded-sm flex items-center justify-center">
                              <img
                                src={amenity?.url}
                                alt=""
                                className="w-8 h-8"
                                style={{
                                  filter: amenity?.isSelected
                                    ? "brightness(0) saturate(100%) invert(52%) sepia(88%) saturate(437%) hue-rotate(167deg) brightness(95%) contrast(95%)"
                                    : "brightness(0.5)",
                                }}
                              />
                            </div>
                          </div>
                          <span className="text-sm font-medium">
                            {amenity?.name}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default Overview;
